import { useMemo } from "react";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";
import useWindowSize from "shared/utils/hooks/useWindowSize";

export const useNotificationPlatformLogo = () => {
  const {
    state: { tenancy, theme },
  } = useGlobalContext();
  const generalTheme = tenancy?.settings?.["general-theme"];

  const organization = tenancy?.organization;
  const shouldUseOrganizationLogo = organization?.use_personalized_logo;

  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 850;

  const plataformIcon = useMemo(
    () => ({
      dark: shouldUseOrganizationLogo
        ? organization?.logo_dark_mode
        : generalTheme?.themeDarkModeLogoIcon,
      light: shouldUseOrganizationLogo
        ? organization?.logo_clear_mode
        : generalTheme?.themeLogoIcon,
    }),
    [theme.value, isMobile],
  );

  const platformLogo = plataformIcon?.[theme?.value];

  return {
    platformLogo,
  };
};
